/*jshint esversion: 6 */
/*jshint sub:true*/

import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';
// import TaktPlanWaggonSideBar from '../views/Project/TaktPlanWaggonSideBar.view.vue';
// import TaktPlanWaggonInfoBox from '../views/Project/TaktPlanWaggonInfoBox.view.vue';
import UserHome from '@/router/components/UserHome.component.js';
//route components
import Project from '@/router/components/Project.component.js';
import ProjectOverView from '@/router/components/ProjectOverView.component.js';
import ProjectTaktPlan from '@/router/components/ProjectTaktPlan.component.js';

import TaktPlanCloudPrints from '@/router/components/TaktPlanCloudPrints.component.js';
import TaktPlanCloudPrintCreate from '@/router/components/TaktPlanCloudPrintCreate.component.js';
import TaktPlanCloudPrintDetails from '@/router/components/TaktPlanCloudPrintDetails.component.js';

import EditCalendar from '@/router/components/EditCalendar.component.js';
import AddTrain from '@/router/components/AddTrain.component.js';
import AddTWaggon from '@/router/components/AddTWaggon.component.js';
import ExtendTWorkPackage from '@/router/components/ExtendTWorkPackage.component.js';

import MilestonesSideBar from '@/router/components/MilestonesSideBar.component.js';
import ProjectMilestones from '@/router/components/ProjectMilestones.component.js';
import ProjectMilestonesAdd from '@/router/components/ProjectMilestonesAdd.component.js';
import ProjectMilestonesDetails from '@/router/components/ProjectMilestonesDetails.component.js';
import ProjectMilestonesEdit from '@/router/components/ProjectMilestonesEdit.component.js';
import TrainMilestones from '@/router/components/TrainMilestones.component.js';
import TrainMilestonesAdd from '@/router/components/TrainMilestonesAdd.component.js';
import TrainMilestonesDetails from '@/router/components/TrainMilestonesDetails.component.js';
import TrainMilestonesEdit from '@/router/components/TrainMilestonesEdit.component.js';

import ProjectWalletStepCard from '@/router/components/ProjectWalletStepCard.component.js';

import TaktPlanWaggon from '@/router/components/TaktPlanWaggon.component.js';
import TaktPlanAddWorkPackageDetails from '@/router/components/TaktPlanAddWorkPackageDetails.component.js';

import ProjectWallet from '@/router/components/ProjectWallet.component.js';
import ProjectWalletTakt from '@/router/components/ProjectWalletTakt.component.js';

import WorkPackageModule from '@/router/modules/WorkPackage.module.js';

import WorkPackageEditorModule from '@/router/modules/WorkPackageEditor.module.js';
import MaterialsOverview from '@/router/modules/MaterialsOverview.module.js';
import WaggonsOverview from '@/router/modules/WaggonsOverview.module.js';
import SequencesOverview from '@/router/modules/SequencesOverview.module.js';
import WorkPackagesOverview from '@/router/modules/WorkPackagesOverview.module.js';

import TrainTaktareaDetails from '@/router/modules/TrainTaktareaDetails.module.js';


//Ultra Route has no complex props or before Enter to keep index.js simple
//In other cases create own router component

import UltraRoute from '@/router/components/UltraRoute.js';
// const UltraRoute = () => import('@/router/components/UltraRoute.js');



Vue.use(VueRouter);

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
const routes = [
  // { path: '/ultraautopilot', name: 'UltraAutopilot', component: () => import ( /* webpackChunkName: "UltraAutopilot" */ '../views/WorkPackageWIP/UltraWorkPackageWIPAutopilot.view.vue'), },
  // { path: '/ultraicon', name: 'UltraIcon', component: () => import ( /* webpackChunkName: "UltraIcon" */ '../views/WorkPackageWIP/UltraIconWIP.view.vue'), },
  // { path: '/ultraautopilotissues', name: 'UltraAutopilotIssues', component: () => import ( /* webpackChunkName: "UltraIcon" */ '../views/WorkPackageWIP/UltraWorkPackageWIPAutopilotIssues.view.vue'), },
  // { path: '/ultraautopilotissuesdetail', name: 'UltraAutopilotIssuesDetail', component: () => import ( /* webpackChunkName: "UltraIcon" */ '../views/WorkPackageWIP/UltraWorkPackageWIPAutopilotIssuesDetail.view.vue'), },


  UltraRoute({name: 'Simulation', path: '/simulation', folder: 'Simulation', props: (route) => {return {name: route.query.name};}}),

  UltraRoute({name: 'Home', path: '/', folder: 'Home', children: [

    

    UltraRoute({name: 'Login', folder: 'Login', redirect: 'LoginOverview', children: [
      UltraRoute({name: 'LoginOverview', path: '', folder: 'LoginOverview'}),
      UltraRoute({name: 'ResetPassword', path: 'reset-password', folder: 'Login'})
    ]}),

    UltraRoute({name: 'Register', folder: 'Register', redirect: 'RegisterOverview', children: [
      UltraRoute({name: 'RegisterOverview', path: '', folder: 'Register'}),
      UltraRoute({name: 'Subscribe', folder: 'Register'}),
      UltraRoute({name: 'Apply', folder: 'Register'}),
      UltraRoute({name: 'Order', folder: 'Register'}),

      UltraRoute({name: 'ApplicationRank', path: 'ranking/:key', folder: 'Register'}),
      UltraRoute({name: 'RegisterAsInvitedUser', path: 'invited', folder: 'Register'}),
    ]}),

    UltraRoute({name: 'TaktApp', folder: 'Home', file: 'HomeDetail', props: {widget: 'taktapp'}, children: [
      UltraRoute({name: 'TaktAppMain', path: 'main', folder: 'Home/TaktApp'}),
      UltraRoute({name: 'TaktAppOne', path: 'one', folder: 'Home/TaktApp'}),
      UltraRoute({name: 'TaktAppTwo', path: 'two', folder: 'Home/TaktApp'}),
      UltraRoute({name: 'TaktAppThree', path: 'three', folder: 'Home/TaktApp'}),
      UltraRoute({name: 'TaktAppFour', path: 'four', folder: 'Home/TaktApp'}),
      UltraRoute({name: 'TaktAppFive', path: 'five', folder: 'Home/TaktApp'}),
      UltraRoute({name: 'TaktAppSix', path: 'six', folder: 'Home/TaktApp'}),
    ]}),

    UltraRoute({name: 'TaktTraining', folder: 'Home', file: 'TaktTraining'}),

    UltraRoute({name: 'TaktingDescription', folder: 'Home', file: 'HomeDetail', props: {widget: 'takting'}, children: [
      UltraRoute({name: 'TaktingDescriptionMain', path: 'main', folder: 'Home/TaktingDescription'}),
      UltraRoute({name: 'TaktingDescriptionOne', path: 'one', folder: 'Home/TaktingDescription'}),
    ]}),

    UltraRoute({name: 'TaktCareer', path: 'careers', folder: 'Home', file: 'HomeDetail', props: {widget: 'taktcareer'}, children: [
      UltraRoute({name: 'GeneralCareer', path: 'general', folder: 'Home/TaktCareer'}),
      UltraRoute({name: 'Career', path: 'jobs/:job_id', folder: 'Home/TaktCareer', props: true}),
    ]}),

    UltraRoute({name: 'AlgorithmicFlow', folder: 'Home', file: 'HomeDetail', props: {widget: 'algorithmicflow'}, children: [
      UltraRoute({name: 'AlgorithmicFlowMain', path: 'main', folder: 'Home/AlgorithmicFlow'}),
      UltraRoute({name: 'AlgorithmicFlowOne', path: 'one', folder: 'Home/AlgorithmicFlow'}),
    ]}),

    UltraRoute({name: 'PowerOfTakt', folder: 'Home', file: 'HomeDetail', props: {widget: 'poweroftakt'}, children: [
      UltraRoute({name: 'PowerOfTaktMain', path: 'main', folder: 'Home/PowerOfTakt'}),
      UltraRoute({name: 'PowerOfTaktOne', path: 'one', folder: 'Home/PowerOfTakt'}),
      UltraRoute({name: 'PowerOfTaktOneMobile', path: 'onemobile', folder: 'Home/PowerOfTakt'}),
      UltraRoute({name: 'PowerOfTaktTwo', path: 'two', folder: 'Home/PowerOfTakt'}),
      UltraRoute({name: 'PowerOfTaktThree', path: 'three', folder: 'Home/PowerOfTakt'}),
      UltraRoute({name: 'PowerOfTaktFour', path: 'four', folder: 'Home/PowerOfTakt'}),
    ]}),

    UltraRoute({name: 'ComingSoon', folder: 'Home', file: 'HomeDetail', props: {widget: 'comingsoon'}, children: [
      UltraRoute({name: 'ComingSoonMain', path: 'main', folder: 'Home/TaktNews'}),
      UltraRoute({name: 'ComingSoonOne', path: 'one', folder: 'Home/TaktNews'}),
      UltraRoute({name: 'ComingSoonTwo', path: 'two', folder: 'Home/TaktNews'}),
      UltraRoute({name: 'ComingSoonThree', path: 'three', folder: 'Home/TaktNews'}),
    ]}),

    UltraRoute({name: 'TaktPartners', folder: 'Home', file: 'HomeDetail', props: {widget: 'taktpartners'}, children: [
      UltraRoute({name: 'TaktPartnersMain', path: 'main', folder: 'Home/TaktPartners'}),
      UltraRoute({name: 'TaktPartnersOne', path: 'one', folder: 'Home/TaktPartners'}),
      UltraRoute({name: 'TaktPartnersTwo', path: 'two', folder: 'Home/TaktPartners'}),
    ]}),

    UltraRoute({name: 'TaktConnection', folder: 'Home', file: 'HomeDetail', props: {widget: 'taktconnection'}, children: [
      UltraRoute({name: 'TaktConnectionMain', path: 'main', folder: 'Home/TaktConnection'}),
      UltraRoute({name: 'TaktConnectionOne', path: 'one', folder: 'Home/TaktConnection'}),
      UltraRoute({name: 'TaktConnectionTwo', path: 'two', folder: 'Home/TaktConnection'}),
    ]}),

    UltraRoute({name: 'Research', folder: 'Home', file: 'HomeDetail', props: {widget: 'research'}, children: [
      UltraRoute({name: 'ResearchMain', path: 'main', folder: 'Home/Research'}),
      UltraRoute({name: 'ResearchInvestBW', path: 'investbw', folder: 'Home/Research'}),
    ]}),

    UltraRoute({name: 'HomeWorkbench', folder: 'Home', file: 'HomeDetail', props: {widget: 'homeworkbench'}, children: [
      UltraRoute({name: 'HomeWorkbenchMain', path: 'main', folder: 'Home/HomeWorkbench'}),
      UltraRoute({name: 'HomeWorkbenchOne', path: 'one', folder: 'Home/HomeWorkbench'}),
      UltraRoute({name: 'HomeWorkbenchTwo', path: 'two', folder: 'Home/HomeWorkbench'}),
    ]}),

  ]}),

  // UltraRoute({name: 'UserHome', path: '/home', folder: 'Home', auth: true, children: [
  UserHome({children: [
    UltraRoute({name: 'UserHomeInvitations', path: 'invitations', folder: 'Home', auth: true}),
    UltraRoute({name: 'UserHomeImages', path: 'images', folder: 'Home', auth: true}),
    UltraRoute({name: 'UserHomeLoglist', path: 'loglist', folder: 'Home', auth: true}),
  ]}),

  UltraRoute({name: 'CompanyHome', path: '/company', folder: 'Company', auth: true, redirect: 'CompanyManage', children: [
    UltraRoute({name: 'CompanyDashboard', path: 'dashboard', folder: 'Company', auth: true}),
    UltraRoute({name: 'CompanyStatistics', path: 'statistics', folder: 'Company', auth: true}),
    UltraRoute({name: 'CompanyProjects', path: 'projects', folder: 'Company', auth: true}),
    UltraRoute({name: 'CompanySettings', path: 'settings', folder: 'Company', auth: true}),
    UltraRoute({name: 'CompanyManage', path: 'manage', folder: 'Company', auth: true, children: [
      UltraRoute({name: 'CompanyAddProjects', path: 'add-projects', folder: 'Company', auth: true}),
      UltraRoute({name: 'CompanyJoinProject', path: 'join-projects', folder: 'Company', auth: true, props: true}),
    ]}),
    UltraRoute({name: 'CompanyIFCImportStrategies', path: 'ifc-strategies', folder: 'Company', auth: true, children: [
      UltraRoute({name: 'CompanyIFCImportStrategiesDetails', path: ':strategy_id', folder: 'Company', file: 'CompanyIFCImportStrategiesDetailsAndCreate', auth: true, props: {create: false}}),
      UltraRoute({name: 'CompanyIFCImportStrategiesCreate', path: 'create', folder: 'Company', file: 'CompanyIFCImportStrategiesDetailsAndCreate', auth: true, props: {create: true}}),
    ]}),
    UltraRoute({name: 'CompanyEmailEndings', path: 'email-endings', folder: 'Company', auth: true, children: [
      UltraRoute({name: 'CompanyEmailEndingsDetails', path: ':email_endings_id', folder: 'Company', auth: true}),
      UltraRoute({name: 'CompanyEmailEndingsCreate', path: 'create', folder: 'Company', auth: true}),
    ]}),
    UltraRoute({name: 'CompanyEntraIdMappers', path: 'entraidmappers', folder: 'Company', auth: true, children: [
      UltraRoute({name: 'CompanyEntraIdMappersDetails', path: ':entra_id_mappers_id', folder: 'Company', auth: true}),
      UltraRoute({name: 'CompanyEntraIdMappersCreate', path: 'create', folder: 'Company', auth: true}),
    ]}),
    UltraRoute({name: 'CompanyClients', path: 'clients', folder: 'Company', auth: true, children: [
      UltraRoute({name: 'CompanyClientsDetails', path: ':client_id', folder: 'Company', auth: true, children: [
        UltraRoute({name: 'CompanyClientsCallbacks', path: 'callbacks', folder: 'Company', auth: true, children: [
          UltraRoute({name: 'CompanyClientsCallbacksDetails', path: ':callback_id', folder: 'Company', auth: true}),
        ]}),
      ]}),
    ]}),
    UltraRoute({name: 'ProcoreClients', path: 'procoreclients', folder: 'Company', auth: true, children: [
      UltraRoute({name: 'ProcoreClientsDetails', path: ':client_id', folder: 'Company', auth: true, children: [
      ]}),
    ]}),
  ]}),

  UltraRoute({name: 'CloudPrintEntryPoint', path: '/cloudprints/:cloudprint_link', folder: 'Project/CloudPrint'}),

  // NOTE: 'ProjectOverViewOnSite'
  // UltraRoute({name: 'ProjectOverView', path: '/projects', folder: 'ProjectOverView', auth: true, children: [
  ProjectOverView({children: [
    UltraRoute({name: 'MultiProjectDetailsDialog', path: '/projects/multiproject-details/:multiproject_id', folder: 'ProjectOverView', auth: true, props: true}),
    UltraRoute({name: 'MultiProjectEditDialog', path: '/projects/multiproject-details/:multiproject_id/edit', folder: 'ProjectOverView', auth: true, props: true}),
  ]}),

  UltraRoute({name: 'ScanQRCodeOnSite', path: '/scanqr', folder: 'ScanQRCode', auth: true}),

  UltraRoute({name: 'Help', path: '/help', folder: 'Help', auth: true, children: [
    UltraRoute({name: 'FAQ', path: 'faq', folder: 'Help', auth: true}),
    UltraRoute({name: 'Tutorials', path: 'tutorials', folder: 'Help', auth: true}),
    UltraRoute({name: 'Contact', path: 'contact', folder: 'Help', auth: true}),
    UltraRoute({name: 'Examples', path: 'examples', folder: 'Help', auth: true}),
    UltraRoute(
      {name: 'Fun', path: 'fun', folder: 'Help/Fun', auth: true, children: [
        UltraRoute({name: 'Pong', path: 'pong', folder: 'Help/Fun', auth: true}),
        UltraRoute({name: 'Minesweeper', path: 'minesweeper', folder: 'Help/Fun', auth: true}),
      ]
      }
    ),
  ]}),

  Project({children: [

    // history
    UltraRoute({name: 'HistProject', path: 'history/:histproject_id', folder: 'Project', file: 'Project', auth: true,
      props: (route) => {
        return {
          location: 'HistProject',
          project_id: parseInt(route.params.project_id),
        };
      }, children: [
        UltraRoute({
          name: 'HistProjectTaktPlan',
          path: 'taktplan',
          folder: 'Project/ProjectTaktPlan',
          file: 'ProjectTaktPlan',
          auth: true,
          props: (route) => {
            return {
              location: 'HistProject',
              project_id: parseInt(route.params.project_id),
              hist_date: route.params.hist_date,
              project: store.state.Ultra.projects[route.params.project_id],
              milestone_id: parseInt(route.params.milestone_id),
              // snackbar: store.state.SnackBar.snackbar,
              selected_wp: parseInt(route.params.tworkpackage_id),
            };
          },
          before_enter: (to, from, next) => {
            let promises = [
              store.dispatch('Ultra/requestUObject', {
                url: [
                  {projects: to.params.project_id},
                  {histprojects: ''},
                  {showWithEntitiesNormalized: ''}
                ]
              }),
              store.dispatch('Ultra/requestUObject', {
                url: [
                  { projects: to.params.project_id },
                  { histprojects: to.params.histproject_id },
                  { showWithEntitiesNormalized: ''}
                ]
              })
            ];
            Promise.all(promises).then(() => {
              next();
            });
          },
          children: [
            // backlogs
            UltraRoute({name: 'HistProjectTaktPlanBacklogs', path: 'backlogs', folder: 'Project/Backlogs', file: 'TaktPlanBacklogs', slot: 'side_bar', auth: true,
              props: {side_bar: () => {
                return {
                  location: 'HistProjectTaktPlanBacklog'
                };
              }},
              children: [
                WorkPackageModule({wallet: false, backlog: true, location: 'HistProjectTaktPlanBacklog', prefix: 'wb'})
              ]
            }),
            // trains
            UltraRoute({
              path: 'trains/:train_id/taktareas/:taktarea_id/waggons/:twaggon_id',
              slot: 'side_bar',
              name: 'HistProjectTaktPlanWaggon',
              folder: 'Project/ProjectTaktPlan',
              file: 'TaktPlanWaggonSideBarRework',
              auth: true,
              props: {
                side_bar: (route) => {
                  return {
                    project_id: parseInt(route.params.project_id),
                    train_id: parseInt(route.params.train_id),
                    taktarea_id: parseInt(route.params.taktarea_id),
                    twaggon_id: parseInt(route.params.twaggon_id),
                    tworkpackage_id: parseInt(route.params.tworkpackage_id),
                    waggon: store.state.Ultra.histtwaggons[route.params.twaggon_id],
                    location: 'HistProjectTaktPlan',
                  };
                },
              },
              children: [
                //workpackage
                WorkPackageModule({wallet: false, location: 'HistProjectTaktPlan', prefix: 't'})
              ]
            })
          ],

        }),
      ]
    }),
    //taktplan
    ProjectTaktPlan({children: [
      UltraRoute({
        slot: 'standard_dialog',
        name: 'TaktPlanTrainDetailsDialog',
        path: 'traindialog',
        folder: 'Project/ProjectTaktPlan',
        auth: true,
        children: [
          TrainTaktareaDetails({location: 'TaktPlan'}),
        ]}),
      UltraRoute({path: 'trains/:train_id/taktareas/:taktarea_id/waggons', redirect: 'Project/ProjectTaktPlan', auth: true}),
      UltraRoute({
        path: 'roadblocks',
        name: 'Roadblocks',
        folder: 'Project/Roadblocks',
        file: 'Roadblocks',
        auth: true,
        slot: 'standard_dialog',
        props: {
          standard_dialog: (route) => {
            return {
              project_id: route.params.project_id,
            };
          }
        },
        children: [
          UltraRoute({
            path: ':twp_id',
            name: 'RoadblockDetails',
            folder: 'Project/Roadblocks',
            file: 'RoadblockDetails',
            auth: true,
          }),
        ]
      }),

      //Cloudprints
      TaktPlanCloudPrints({children: [
        TaktPlanCloudPrintDetails(),
        TaktPlanCloudPrintCreate()
      ]}),
      // HistoryProjects
      UltraRoute({
        path: 'historyprojects',
        folder: 'Project/History',
        file: 'HistoryProjects',
        name: 'TaktPlanHistoryProjects',
        auth: true,
        slot: 'standard_dialog',
        props: {
          standard_dialog: (route) => {
            return {
              histprojects: store.getters['Ultra/getUObjects']({
                type: 'histprojects',
                ids: store.state.Ultra.projects[route.params.project_id].histprojects
              }),
              project_name: store.state.Ultra.projects[route.params.project_id].name,
              project_id: route.params.project_id,
            };
          }
        },
        children: [
          UltraRoute({path: ':histproject_id', folder: 'Project/History', name: 'TaktPlanHistoryProjectDetails', file: 'HistoryProjectDetails', auth: true, props: (route) => {
            return {
              historyproject: store.state.Ultra.histprojects[route.params.histproject_id],
              project_id: route.params.project_id,
              location: 'ProjectTaktPlan',
            };
          }}),
          UltraRoute({path: 'create', folder: 'Project/History', name: 'TaktPlanHistoryProjectCreate', file: 'HistoryProjectCreate', auth: true, props: (route) => {
            return {
              project_id: parseInt(route.params.project_id),
              location: 'ProjectTaktPlan',
            };
          }}),
        ]
      }),
      //Calendar
      EditCalendar(),
      //AddTrain
      AddTrain(),
      AddTWaggon(),
      ExtendTWorkPackage(),
      //MileStones
      MilestonesSideBar({children:[
        ProjectMilestones({children: [
          ProjectMilestonesAdd(),
          ProjectMilestonesDetails(),
          ProjectMilestonesEdit(),
        ]}),
        TrainMilestones({children: [
          TrainMilestonesAdd(),
          TrainMilestonesDetails(),
          TrainMilestonesEdit(),
        ]})
      ]}),
      //Backlogs
      UltraRoute({name: 'TaktPlanBacklogs', path: 'backlogs', folder: 'Project/Backlogs', slot: 'side_bar', auth: true,
        props: {side_bar: () => {
          return {
            location: 'ProjectTaktPlanBacklog'
          };
        }},
        children: [
          UltraRoute({name: 'TaktPlanAddWBWorkPackage', file: 'TaktPlanAddWorkPackage', path: 'groups/:wbgroup_id/lines/:wbline_id/addwbworkpackage', folder: 'Project/TaktPlanWorkPackage', props: {backlog: true}, auth: true, children: [
            WorkPackageEditorModule({
              path: 'create',
              name: 'TaktPlanBacklogAddWorkPackageCreateEditor',
              read_only: false,
              create: true,
              prefix: 'template_type',
              prefix_two: 'w',
              nav_back: 'TaktPlanAddWBWorkPackage',
              location: 'TaktPlanAddWB',
            }),
            TaktPlanAddWorkPackageDetails({name: 'TaktPlanAddWBWorkPackageDetails', backlog: true, children: [
              WorkPackageEditorModule({
                path: 'edit',
                name: 'TaktPlanAddWBWorkPackageDetailsEditEditor',
                read_only: false,
                create: false,
                prefix: 'template_type',
                prefix_two: 'w',
                nav_back: 'TaktPlanAddWBWorkPackage',
                location: 'TaktPlanAddWB',
              }),

            ]}),
          ]}),
          WorkPackageModule({wallet: false, backlog: true, location: 'TaktPlanBacklog', prefix: 'wb'})
        ]
      }),

      //Waggon
      TaktPlanWaggon({children: [
        //false path redirect
        UltraRoute({path: 'workpackages', redirect: 'TaktPlanWaggon', auth: true}),
        //add workpackage
        UltraRoute({name: 'TaktPlanAddWorkPackage', path: 'addworkpackage', folder: 'Project/TaktPlanWorkPackage', auth: true, children: [
          WorkPackageEditorModule({
            path: 'create',
            name: 'TaktPlanTrainAddWorkPackageCreateEditor',
            read_only: false,
            create: true,
            prefix: 'template_type',
            prefix_two: 'w',
            nav_back: 'TaktPlanAddWorkPackage',
            location: 'TaktPlanAddWB',
          }),
          TaktPlanAddWorkPackageDetails({children: [
            WorkPackageEditorModule({
              path: 'edit',
              name: 'TaktPlanAddWorkPackageDetailsEditEditor',
              read_only: false,
              create: false,
              prefix: 'template_type',
              prefix_two: 'w',
              nav_back: 'TaktPlanAddWorkPackageDetails',
              location: 'TaktPlanAdd',
            }),
          ]})
        ]}),
        //workpackage
        WorkPackageModule({wallet: false, backlog: false, prefix: 't', location: 'TaktPlan'})
      ]})
    ]}),
    //wallet
    ProjectWallet({children: [
      //wallet takt
      ProjectWalletTakt({children: [
        //stepcards
        ProjectWalletStepCard({step_type: 'Work'}),
        ProjectWalletStepCard({step_type: 'Quality'}),
        ProjectWalletStepCard({step_type: 'Defect'}),
        ProjectWalletStepCard({step_type: 'Handover'}),
        ProjectWalletStepCard({step_type: 'Design'}),
        ProjectWalletStepCard({step_type: 'Logistic'}),
        //workpackage
        WorkPackageModule({wallet: true, backlog: false, prefix: 't', location: 'ProjectWallet'}),
        //train taktarea details
        TrainTaktareaDetails({location: 'ProjectWallet'})
      ]})
    ]}),
    UltraRoute({name: 'ProjectSettings', path: 'settings', folder: 'Project/ProjectSettings', auth: true, redirect: 'ProjectInformation', children: [
      UltraRoute({name: 'ProjectInformation', path: 'information', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectData', path: 'data', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectMembers', path: 'members', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectPay', path: 'pay', folder: 'Project/ProjectSettings', auth: true, children: [
        UltraRoute({name: 'ProjectPayCurrentInvoice', path: ':invoice_id', folder: 'Project/ProjectSettings', auth: true}),
      ]}),
      // UltraRoute({name: 'ProjectAutopilots', path: 'autopilots', folder: 'Project/ProjectSettings', auth: true, props: true}),
      UltraRoute({name: 'ProjectClients', path: 'clients', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectMessageBoard', path: 'messageboard', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectInviteWPSelectTaktPlan', path: 'select-work-packages', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectDelete', path: 'delete', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectResetEditMode', path: 'reset-edit-mode', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectStatistics', path: 'statistics', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectTaktboxes', path: 'taktboxes', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectLogList', path: 'logs', folder: 'Project/ProjectSettings', auth: true}),
      UltraRoute({name: 'ProjectWorkPackageList', path: 'wp-list', folder: 'Project/ProjectSettings', auth: true}),
    ]}),
    UltraRoute({name: 'ProjectTaktJournal', path: 'taktjournal', folder: 'Project/ProjectTaktJournal', auth: true}),
    UltraRoute({name: 'ProjectWalletPrint', path: 'wallet-print/trains/:train_id/taktareas/:taktarea_id/waggons/:twaggon_id/workpackages/:tworkpackage_id', folder: 'Project/ProjectWalletPrint', auth: true}),
    {
      path: 'projectstructure',
      name: 'ProjectStructure',
      component: () => import( /* webpackChunkName: "ProjectSettings" */ '../views/Project/ProjectStructureRework/ProjectStructure.view.vue'),
      props: (route) => {
        return {
          project_id: parseInt(route.params.project_id),
          project: store.state.Ultra.projects[route.params.project_id],
        };
      },
      meta: {
        requiresAuth: true
      },
      // beforeEnter: (to, from, next) => {
      //   store.dispatch('Ultra/requestUObject', {
      //     url: [
      //       {projects: parseInt(to.params.project_id)},
      //       {projectstructure: ''}
      //     ],
      //   }).then(() => {
      //       next();
      //   });
      // },
      children: [
        {
          path: 'details/:type/:structure_id',
          name: 'ProjectStructureDetails',
          component: () => import( /* webpackChunkName: "ProjectSettings" */ '../views/Project/ProjectStructure/ProjectStructureDetails.view.vue'),
          props: (route) => {
            return {
              project_id: parseInt(route.params.project_id),
              element: store.getters['UltraDev/getUDObject']({
                type: route.params.type,
                id: route.params.structure_id
              })
            };
          },
          meta: {
            requiresAuth: true
          },
          children: [
          {
            path: 'plans/:plan_id',
            name: 'ProjectStructurePlans',
            component: () => import( /* webpackChunkName: "ProjectSettings" */ '../views/Project/ProjectStructure/ProjectStructurePlans.view.vue'),
            props: (route) => {
              return {
                project_id: parseInt(route.params.project_id),
                element: route.params.spatial_units_location?
                  store.getters['UltraDev/getUDObject']({
                    type: route.params.spatial_units_location.plan_parent_type,
                    id: route.params.spatial_units_location.plan_parent_id
                  })
                  :
                  store.getters['UltraDev/getUDObject']({
                    type: route.params.type,
                    id: route.params.structure_id
                  }),
                selected_plan: route.params.plan_id !== 'create'?
                  store.getters['UltraDev/getUDObject']({
                    type: 'plans',
                    id: route.params.plan_id
                  }):false,
              };
            },
            meta: {
              requiresAuth: true
            },
          }
        ]
        },
        {
          path: 'addtrain',
          name: 'ProjectStructureAddTrain',
          component: () => import( /* webpackChunkName: "ProjectTaktPlanWaggonInfoBox" */ '@/views/Project/ProjectTaktPlan/TaktPlanAddTrainSideBar.view.vue'),
          props: (route) => {
              return {
                project_id: parseInt(route.params.project_id),
                train_index: parseInt(route.params.train_index),
                train_id: parseInt(route.params.train_id),
                direction: parseInt(route.params.direction),
              };
          },
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    UltraRoute({name: 'ProjectAutoPilots', path: 'autopilots', folder: 'Project/ProjectAutoPilots', auth: true, children: [
        UltraRoute({name: 'ProjectAutoPilotsAdd', path: 'add', folder: 'Project/ProjectAutoPilots', auth: true, children: [
          UltraRoute({name: 'ProjectAutoPilotsAddDetails', path: ':autopilot_add_id/details', folder: 'Project/ProjectAutoPilots', auth: true}),
        ]}),
        UltraRoute({name: 'ProjectAutoPilotsDetails', path: ':autopilot_id/details', folder: 'Project/ProjectAutoPilots', auth: true}),
    ]}),
    ]
  }),

  UltraRoute({name: 'MultiProjectSchedule', path: '/multiprojects/:multiproject_id/schedule', folder: 'MultiProject', auth: true}),

  {
    path: '/settings',
    name: 'GeneralSettings',
    component: () => import( /* webpackChunkName: "GeneralSettings" */ '../views/GeneralSettings/GeneralSettings.view.vue'),
  },
  {
    path: '/accounts',
    redirect: {
      name: 'AccountInvitations'
    },
    name: 'Account',
    meta: {
      requiresAuth: true
    },
    component: () => import( /* webpackChunkName: "Account" */ '../views/Account/Account.view.vue'),
    children: [
      {
        path: 'invitations',
        name: 'AccountInvitations',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountInvitations.view.vue'),
      },
      {
        path: 'information',
        name: 'AccountInfo',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountInfo.view.vue'),
      },
      {
          path: 'messages',
          name: 'AccountMessages',
          meta: {
            requiresAuth: true
          },
          component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountMessages.view.vue'),
        },
      {
        path: 'clients',
        name: 'AccountClients',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountClients.view.vue'),
        children: [
          {
            path: ':client_id/addprojects',
            name: 'AccountClientsAddProjects',
            meta: {
              requiresAuth: true
            },
            props: true,
            component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountClientsAddProjects.view.vue'),
          }
        ]
      },
      {
        path: 'settings',
        name: 'AccountSettings',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountSettings.view.vue'),
        children: [
          {
            path: 'upgrade-full-user',
            name: 'AccountSettingsUserUpgradeFullUser',
            meta: {
              requiresAuth: true
            },
            component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountSettingsUserUpgradeFullUser.view.vue'),
          },
          {
            path: 'upgrade-pro-user',
            name: 'AccountSettingsUserUpgradeProUser',
            props: true,
            meta: {
              requiresAuth: true
            },
            component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountSettingsUserUpgradeProUser.view.vue'),
          },
          {
            path: 'upgrade-pro-user-integration',
            name: 'AccountSettingsUserUpgradeProUserIntegration',
            props: true,
            meta: {
              requiresAuth: true
            },
            component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountSettingsUserUpgradeProUserIntegration.view.vue'),
          },
          {
            path: 'upgrade-pro-user-bi',
            name: 'AccountSettingsUserUpgradeProUserBI',
            props: true,
            meta: {
              requiresAuth: true
            },
            component: () => import( /* webpackChunkName: "Account" */ '../views/Account/AccountSettingsUserUpgradeProUserBI.view.vue'),
          },
        ]
      },
    ]
  },
  {
    path: '/workbench',
    name: 'WorkBench',
    meta: {
      requiresAuth: true
    },
    // component: () => import( /* webpackChunkName: "WorkBench" */ '../views/WorkBench/WorkBench.view.vue'),
    component: () => import( /* webpackChunkName: "WorkBench" */ '../views/WorkBenchRework/WorkBench.view.vue'),
    redirect: {name: 'WorkBenchSequences', params: {template_type: 'custom', sfolder: 'last-updated'}},
    children: [
      SequencesOverview({location: 'WorkBench'}),
      WorkPackagesOverview({location: 'WorkBench'}),
      WaggonsOverview({location: 'WorkBench'}),
      MaterialsOverview({location: 'WorkBench'}),
    ]
  },
  {
    path: '/community-work-packages',
    name: 'CommunityWorkPackagesOld',
    meta: {
      requiresAuth: true
    },
    // /* webpackChunkName: "WorkBench" */ 
    component: () => import(
    '../views/WorkBench/CommunityWorkPackages.view.vue'),
  },
  {
    path: '/custom-work-step',
    name: 'CustomWorkStep',
    meta: {
      requiresAuth: true
    },
    // /* webpackChunkName: "WorkBench" */ 
    component: () => import(
    '../views/WorkBench/CustomWorkStep.view.vue'),
  },
  {
    path: '/community-work-steps',
    name: 'CommunityWorkSteps',
    meta: {
      requiresAuth: true
    },
    // /* webpackChunkName: "WorkBench" */ 
    component: () => import(
    '../views/WorkBench/CommunityWorkSteps.view.vue'),
  },
  {
    path: '/dashboard',
    redirect: {
      name: 'UserSearch'
    },
    name: 'Dashboard',
    meta: {
      requiresAuth: true
    },
    component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/Dashboard.view.vue'),
    children: [
      {
        path: 'stats',
        name: 'Stats',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/Stats.view.vue'),
      },
      {
        path: 'taktnews',
        name: 'TaktNews',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/TaktNews.view.vue'),
      },
      {
        path: 'community',
        name: 'Community',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/Community.view.vue'),
      },
      {
        path: 'user-invites',
        name: 'UserInvites',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/UserInvites.view.vue'),
      },
      {
        path: 'recently-active',
        name: 'RecentlyActiveUser',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/RecentlyActiveUser.view.vue'),
      },
      {
        path: 'user-search',
        name: 'UserSearch',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/UserSearch.view.vue'),
      },
      {
        path: 'user-upgrades',
        name: 'UserUpgrades',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/UserUpgrades.view.vue'),
      },
      {
        path: 'pro-user',
        name: 'ProUser',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/ProUser.view.vue'),
      },
      {
        path: 'bugreports',
        name: 'BugReports',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/BugReports.view.vue'),
      },
      {
        path: 'material-api-dashboard',
        name: 'MaterialAPIDashboard',
        meta: {
          requiresAuth: true
        },
        component: () => import( /* webpackChunkName: "Dashboard" */ '../views/Dashboard/MaterialAPIDashboard.view.vue'),
      }
    ]
  },
  {
    path: '/ai-dashboard',
    name: 'AIDashboard',
    component: () => import( /* webpackChunkName: "AIDashboard" */ '../views/AIDashboard/AIDashboard.view.vue'),
    children: [
    {
        path: 'wp-similar',
        name: 'WPSimilarity',
        component: () => import( /* webpackChunkName: "AIDashboard" */ '../views/AIDashboard/WPSimilarity.view.vue'),
    },
    {
        path: 'wp-country',
        name: 'WPCountry',
        component: () => import( /* webpackChunkName: "AIDashboard" */ '../views/AIDashboard/WPCountry.view.vue'),
    },
    {
        path: 'wp-order',
        name: 'WPOrder',
        component: () => import( /* webpackChunkName: "AIDashboard" */ '../views/AIDashboard/WPOrder.view.vue'),
    },
  ]
  },
  {
    path: '/legal-notice',
    name: 'LegalNotice',
    component: () => import( /* webpackChunkName: "LegalNotice" */ '../views/LegalNotice.view.vue'),
    props: true
  },
  {
    path: '/aws-auth',
    name: 'AWSAuth',
    component: () => import( /* webpackChunkName: "LegalNotice" */ '../views/AWSAuth.view.vue'),
  },
  {
    path: '/codes',
    name: 'QRCodeRouter',
    component: () => import( /* webpackChunkName: "LegalNotice" */ '../views/QRCodeRouter.view.vue'),
  },
  {
    path: '/aws-redirect',
    name: 'AWSRedirect',
    component: () => import( /* webpackChunkName: "LegalNotice" */ '../views/AWSRedirect.view.vue'),
  },
  {
    path: '/resend-invitation',
    name: 'ResendInvitation',
    component: () => import( /* webpackChunkName: "LegalNotice" */ '../views/ResendInvitation.view.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import( /* webpackChunkName: "NotFound" */ '../views/NotFound.view.vue'),
  },
];
//functions
const router = new VueRouter({
  routes: routes,
  mode: 'history'
});


router.beforeEach((to, from, next) => {
  // store is defined here
  if (to.name === 'Home' && store.getters['Auth/isLoggedIn']) {
    next({
      name: 'ProjectOverView'
    });
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters['Auth/isLoggedIn']) {
        if (store.getters['Auth/getUserId'] === 0) {
          store.dispatch('Auth/initUser', true).then( () => {
            next();
          });
        } else {
          // store.dispatch('Message/requestMessagesCurrentUser').then( () => {
          //   next();
          // });
          store.dispatch('Message/requestMessagesCurrentUser');
          next();
        }
      } else if (store.state.Auth.cloudprint_token !== '') {
        next();
      } else {
        next({
          name: 'AWSRedirect',
          query: {
            redirect: to.fullPath
          }
        });
      }
    } else {
      next();
    }
  }
});
router.afterEach((to, from) => {
  if (
      from.matched[0] && from.matched[0].name === 'Project' && to.matched[0] && !(to.matched[0].name === 'Project' || to.matched[0].name === 'MultiProjectSchedule')
    ) {
    store.dispatch('Ultra/resetUState', {
      keys: [
        'trains',
        'taktareas',
        'twaggons',
        'tworkpackages',
        'tworksteps',
        'tdefectsteps',
        'tqualitysteps',
        'thandoversteps',
        'tlogisticsteps',
        'tdesignsteps',
        'tcoststeps',
        'tworkpackageimages',
        'sites',
        'spatialzones',
        'buildings',
        'buildingstoreys',
        'spacegroups',
        // 'spatialunits',
        'elements',
        'plans',
        'locations',
        'cloudprints'
      ],
      params: from.params
    })
  }
})
router.onError(error => {
  console.error(error);
  console.log(error.message);
  // Vue.prototype.$log.error('Failure Reason: ', error.message, error);
  if (/ChunkLoadError:.*failed./i.test(error.message)) {
    console.log('error 1');
    window.location.reload();
  }
  else if (/Loading.*chunk.*failed./i.test(error.message)) {
    console.log('error 2');
    // window.location.reload();
  } else if (error.message.includes('Loading chunk')) {
    console.log('error 3');
    // window.location.reload();
  }
});

export default router;
